import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/react'
import * as Flickity from 'react-flickity-component'
import styled from '@emotion/styled'
import '~styles/flickity.css'
import Section from './Section'
import { mobile, InsetSection} from '~styles/global'
import Image from '~components/Image'
import Video from '~components/Video'

const MarqueeSlider = ({className, slides}) => {

	let requestId
	let n = 0
	let flkty = null

	const play = () => {
		// Set the decrement of position x
		window.cancelAnimationFrame(requestId)
		if (flkty) {
			flkty.x = flkty.x - 0.5
			// Settle position into the slider
			flkty.settle(flkty.x)
			// Set the requestId to the local variable
			requestId = window.requestAnimationFrame(play)
		}
	}

	const easeOut = () => {
		if(requestId) {
			// Cancel the animation
			window.cancelAnimationFrame(requestId)
			n++
			flkty.x = flkty.x - (1 - (n / 50)) * 0.5
			flkty.settle(flkty.x)
			// Reset the requestId for the next animation.
			requestId = window.requestAnimationFrame(easeOut)
			if(n > 50){
				pause()
			}
		}
	}

	const pause = () => {
		if(requestId) {
			// Cancel the animation
			window.cancelAnimationFrame(requestId)
			// Reset the requestId for the next animation.
			requestId = undefined
			n = 0
		}
	}
  
	useEffect(()=> {
		play()
		flkty?.on( 'dragStart', function( event, pointer ) {
			pause()
		})
	}, [])

	const flickityOptions = {
		prevNextButtons: false,
		pageDots: false,
		adaptiveHeight: false,
		wrapAround: true,
		cellAlign: 'left',
		freeScroll: true,
		contain: true,
		// cellAlign: 'center',
	}
	return(
		slides?.length > 1 ?
			<Wrap className={className}>
				<Container 
					onMouseLeave={()=> play()}
					onMouseEnter={()=> easeOut()}
				// onMouseDown={() => setInteracted(true)}
				>
					<Flickity
						flickityRef={c => flkty = c}
						className={'carousel'} // default ''
						elementType={'div'} // default 'div'
						options={flickityOptions} // takes flickity options {}
						disableImagesLoaded={false} // default false
						// static // default false
						css={sliderCss}
					>
						{[...Array(5)].map(i => (
							<React.Fragment key={i}>
								{slides?.map(slide => (
									slide?.mediaType === 'video' ? 
										<Slide key={slide._key} aspectRatio={slide.videoAspectRatio} css={css`
									`}>
											<StyledVideo src={slide?.video?.video?.asset?.url} />
										</Slide>
										: 
										<Slide key={slide._key} aspectRatio={slide?.image?.asset?.metadata?.dimensions?.aspectRatio}>
											<Image image={slide.image} />
										</Slide>
								))}
							</React.Fragment>
						))}
					
					</Flickity>
				</Container>
			</Wrap>
			:
			<InsetSection>
				<SingleSlide>
					{slides?.map(slide => (
						slide?.mediaType === 'video' ? 
							<StyledVideo src={slide?.video?.video?.asset?.url} key={slide._key} />
							: 
							<Image image={slide.image} key={slide._key}/>
					))}
				</SingleSlide>
			</InsetSection>
	)
}

const Wrap = styled(Section)`
 overflow: hidden;
`
const Container = styled.div`
	grid-column: span 12;
	margin: 0 -30px;
`
const sliderCss = css`
`

const Slide = styled.div`
	position: absolute;
	top: 0;
	left: 5px;
	width: ${props => 659 * props.aspectRatio}px;
	z-index: 100;
	height: 659px;
	${mobile}{
		height: 320px;
		width: ${props => 320 * props.aspectRatio}px;
	}
`
const StyledVideo = styled(Video)`
	position: absolute;
	top: 0;
	bottom: 0;
	height: 100%;
	transform: scale(1.01);
`

const SingleSlide = styled.div`
	grid-column: span 6;
	margin: 70px 0;
	${mobile}{
		margin: 50px 0;
		grid-column: span 12;
	}
`
MarqueeSlider.propTypes = {
	className: PropTypes.string,
	slides: PropTypes.object,
}

export default MarqueeSlider
